import BclImageUpload from './ImageUpload.vue';
export default BclImageUpload;